import { connect } from 'react-redux'
import { CookiesConsentComponent } from './CookiesConsentComponent'
import { consentAllCookies, declineAllCookies } from 'shared/store/user'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'

const mapStateToProps = (state: RootState) => {
    const { cookiesConsentsDone, manageCookies } = state.userState
    return {
        cookiesConsentsDone,
        manageCookies
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    consentAllCookies: () => d(consentAllCookies()),
    declineAllCookies: () => d(declineAllCookies())
})

const CookiesConsent = connect(
    mapStateToProps,
    mapDispatchToProps
)(CookiesConsentComponent)

export { CookiesConsent }
